
import useGncHistory from '../../../hooks/useGncHistory'

const CancelButton = (props) => {
    const navigateOverride = props.navigateOverride || null
    
    const {
        goBack,
    } = useGncHistory()
    
    const handleCancel = (event) => {
        event.preventDefault()
        if( navigateOverride ) {
            navigateOverride()
        } else {
            goBack()
        }
    }

    return (
        <button className="btn btn-white btn-mr" type="button" onClick={handleCancel}>Cancel</button>
    )
}

export default CancelButton
